<template>
    <div :class="cssParentClass">
        <label class="control-label" v-if="name" :for="id">{{ name }}</label>
        <input
                v-if="type === 'password'"
                :placeholder="placeholder"
                :value="value"
                :id="id"
                :class="cssClass"
                :disabled="disabled"
                @input="onInput($event.target.value)"
                type="password" />
        <input
                v-else
                :placeholder="placeholder"
                :value="value"
                :id="id"
                :class="cssClass"
                :disabled="disabled"
                @input="onInput($event.target.value)"
                :type="type"
                :readonly="readOnly"
        />
        <span class="help-block" v-if="error">{{ error }}</span>
    </div>
</template>

<script>
export default {
  name: 'Field',
  components: {},
  props: {
    id: String,
    name: String,
    type: {
      type: String,
      default: 'text'
    },
    value: [String, Number],
    placeholder: {
      type: String,
      default: ''
    },
    disabled: Boolean,
    error: String,
    readOnly: Boolean
  },
  computed: {
    cssParentClass () {
      return `field${this.error ? ' has-error' : ''}`
    },
    cssClass () {
      return 'form-control'
    }
  },
  methods: {
    onInput (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss">
    .field {
      &--error {

      }
    }
</style>



// WEBPACK FOOTER //
// src/components/Form/Field/field.vue